
<script>
	import { db } from '../../firebase';
	import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';
    import { user } from '../../store'
    
    import CardListStore from '../../components/organisms/CardList/CardListStore.svelte';

    // get YOUR ideas (public and private secured but NO drafts)
    var 	query = db.collection('ideas').where('uid', '==', $user.uid).where('isSecured', '==', true).orderBy('timestamp', 'desc'),
            ideas = collectionData(query, 'id').pipe(startWith([]));

</script>

<CardListStore {ideas} page="vault" />